<template>
  <div>
    <fieldset :disabled="is_loading" class="position-basics">
    <div>
      <div>
        <p class="bold">חלון מספר 1 מתוך 2</p>
      </div>
      <div>
        <p><b>Position Title *</b></p>
        <input ref="title" v-model="position_title" maxlength="255" class="outlined full_width" placeholder='מנהל צוות בחברת נדלן'>
      </div>
      <div>
        <p><b>Owner</b></p>
        <input ref="owner" v-model="owner" maxlength="255" class="outlined full_width">
      </div>
      <div>
        <p><b>Message</b></p>
        <input ref="message" v-model="message" maxlength="500" class="outlined full_width">
      </div>
    </div>
    </fieldset>
    <div class="modal_footer" style="justify-content: space-between;">
      <button type="button" :disabled="is_loading"
        @click="continueToStepTwo()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >המשך לשלב הבא</button
      >
      <p><b>שלב ראשון</b></p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { newPositionAssistantSession } from '@/custom/classes/position_assistant'
export default {
  name: 'create-position-step-one',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      position_title: '',
      owner: this.$utils.getOwner().name,
      message: ''
    }
  },
  methods: {
    continueToStepTwo () {
      if (this.is_loading) return
      if (!this.position_title.trim()) {
        this.$utils.emit('show_toast', { text: 'Position Title ריק' })
        return
      }
      this.is_loading = true
      this.$network_utils.createPosition({ title: this.position_title, current_company_id: this.payload.company_id, owner: this.owner, message: this.message, status: 'editing', active_at: new Date() })
        .then(response => {
          this.is_loading = false
          this.create({
            designator: 'create-position-step-two',
            component_name: 'ModalPosition',
            ignore_escape_button: true,
            data: response,
            // The AI quick-fill lives only in this second window.
            assistant_session: newPositionAssistantSession(),
            modal_width: 1500,
            is_center_modal: true,
            modal_title: 'Create new Position - חלון מספר 2 מתוך 2'
          })
          this.remove(this.payload)
          this.$utils.emit('show_toast', { text: 'success' })
        }).catch(() => {
          this.is_loading = false
          this.$utils.emit('show_toast', { text: 'ארעה שגיאה' })
        })
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>

<style scoped>
.position-basics { border: 0; padding: 0; margin: 0; min-width: 0; }
</style>
